import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { Filter, Main } from 'Containers';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { FAMILY_MATCH_UTILITY_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { FamilyMatchUtilityFormEnum as Fields } from 'Common/FieldEnum';

import {
  addAppToHistory,
  addSelectedStudentIdSeed,
  checkApplicationRow,
  checkStudentRow,
  clearError,
  clearSelectedStudents,
  getApplicationsAndStudents,
  removeSelectedStudentIdSeed,
  setNoStudent,
  setSaveSuccessful,
  setSelectedConfidence,
  setSelectedIds,
  toggleHistory,
  writeApplicationWithStudentMatch,
} from './state/actions';
import * as Selectors from './state/selectors';
import { FamilyMatchUtilityApplicationTable } from './components/FamilyMatchUtilityApplicationTable';
import { FamilyMatchUtilityStudentTable } from './components/FamilyMatchUtilityStudentTable';
import { FamilyMatchUtilityForm } from './components/FamilyMatchUtilityForm';

class FamilyMatchUtilityContainer extends Component {
  getMainProps = () => {
    const { fetching } = this.props;
    return {
      toolbox: {
        formName: FAMILY_MATCH_UTILITY_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: fetching,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getApplicationsAndStudents(this.props.selectedConfidence);
  }

  componentDidUpdate(prevProps) {
    const {
      addAppToHistory,
      clearError,
      getApplicationsAndStudents,
      noStudentFound,
      savedSuccessfully,
      selectedConfidence,
      setNoStudent,
      setSaveSuccessful,
      setSelectedIds,
      selectedSystemId,
      applicationData,
    } = this.props;

    if (noStudentFound && prevProps.noStudentFound !== noStudentFound) {
      createToast(toastType.info, 'Results', 'No data found!');
      setNoStudent(false);
    }

    if (errorToast(this.props, prevProps, 'fetchError')) {
      clearError();
    }

    if (savedSuccessfully) {
      addAppToHistory(
        applicationData.filter((x) => x.SystemId === selectedSystemId)[0]
      );
      createToast(
        toastType.success,
        'Success',
        'Student saved to application. See it in the Previously Matched tab.',
        true,
        15000
      );
      setSaveSuccessful(false);
      getApplicationsAndStudents(selectedConfidence);
      setSelectedIds({ SystemId: null, HHId: null });
    }
  }

  toggleHistoryHandler = (value) => {
    this.props.toggleHistory(value);
  };

  handleSubmit = (values) => {
    const {
      applicationData,
      studentData,
      writeApplicationWithStudentMatch,
    } = this.props;

    const appIsSelected = applicationData.find((row) => row.Selected === true);
    const selectedStudents = studentData.filter((row) => row.Selected === true);

    if (appIsSelected && selectedStudents.length > 0) {
      const selectedIdSeeds = selectedStudents.map((a) => a.IdSeed);
      const sendMe = {
        StudentIdSeeds: selectedIdSeeds,
        SystemId: appIsSelected.SystemId,
      };
      writeApplicationWithStudentMatch(sendMe);
    }
    if (appIsSelected && selectedStudents.length === 0) {
      createToast(
        toastType.error,
        'Error',
        'Must choose an Application and a Student to match.'
      );
    }
  };

  render() {
    const {
      applicationData,
      clearSelectedStudents,
      selectedConfidence,
      fetchingApplications,
      fetchingStudents,
      filteredStudentData,
      setSelectedConfidence,
      selectedSystemId,
      checkApplicationRow,
      checkStudentRow,
      setSelectedIds,
      addSelectedStudentIdSeed,
      removeSelectedStudentIdSeed,
      getApplicationsAndStudents,
      isHistoryShown,
      alteredApplications,
    } = this.props;

    return (
      <Fragment>
        <Filter
          title="Family Match"
          style={{
            width: 400,
          }}
        />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <TitledCard title={'Family Match Utility'}>
            <FamilyMatchUtilityForm
              onSubmit={this.handleSubmit}
              applicationData={applicationData}
              getApplicationsAndStudents={getApplicationsAndStudents}
              initialValues={{ [Fields.ConfidenceDropdown]: 0 }}
              setSelectedConfidence={setSelectedConfidence}
              fluid
              selectedSystemId={selectedSystemId}
              setSelectedIds={setSelectedIds}
              clearSelectedStudents={clearSelectedStudents}
            />
          </TitledCard>
          <TitledCard title={'Select Application & Student'}>
            <span>
              <Button onClick={() => this.toggleHistoryHandler(false)} animated>
                <Button.Content visible>Matching</Button.Content>
                <Button.Content hidden>
                  <Icon name="check" />
                </Button.Content>
              </Button>
              <Button onClick={() => this.toggleHistoryHandler(true)} animated>
                <Button.Content visible>Previously Matched</Button.Content>
                <Button.Content hidden>
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 64 64"
                  >
                    <g>
                      <path
                        d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
		                      S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
                      />
                      <path d="M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z" />
                    </g>
                  </svg>
                </Button.Content>
              </Button>
            </span>

            {isHistoryShown ? (
              <React.Fragment>
                <br />
                {alteredApplications.length === 0 ? (
                  <React.Fragment>
                    <br />
                    <p style={{ color: 'gray' }}>{'(None)'}</p>
                  </React.Fragment>
                ) : (
                  alteredApplications.map((x) => {
                    return (
                      <React.Fragment>
                        <br />
                        <Link
                          to={'/manageapplication/' + x.SystemId.toString()}
                        >
                          {x.FirstName + ' ' + x.LastName + "'s Application"}
                        </Link>
                        <br />
                      </React.Fragment>
                    );
                  })
                )}
              </React.Fragment>
            ) : (
              <div>
                <br />
                <h4>Applications</h4>
                <FamilyMatchUtilityApplicationTable
                  loading={fetchingApplications}
                  applicationData={applicationData}
                  checkApplicationGrid={checkApplicationRow}
                  onSelect={setSelectedIds}
                  selectedConfidence={selectedConfidence}
                />
                <br />
                <h4>Unmatched Students</h4>
                <FamilyMatchUtilityStudentTable
                  checkStudentGrid={checkStudentRow}
                  onSelect={addSelectedStudentIdSeed}
                  onRemove={removeSelectedStudentIdSeed}
                  studentData={filteredStudentData}
                  fluid
                  loading={fetchingStudents}
                />
              </div>
            )}
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    applicationData: Selectors.getApplicationData(state),
    studentData: Selectors.getStudentData(state),
    filteredStudentData: Selectors.getStudentsByHHId(state),
    selectedSystemId: Selectors.getSelectedSystemId(state),
    selectedHHId: Selectors.getSelectedHHId(state),
    selectedStudentIdSeeds: Selectors.getSelectedStudentIdSeeds(state),
    selectedConfidence: Selectors.getSelectedConfidence(state),
    fetchingApplications: Selectors.getFetchingApplications(state),
    fetchingStudents: Selectors.getFetchingStudents(state),
    fetchError: Selectors.getError(state),
    savedSuccessfully: Selectors.getSavedSuccessfully(state),
    noStudentFound: Selectors.getNoStudentsFlag(state),
    isHistoryShown: Selectors.getHistoryState(state),
    alteredApplications: Selectors.getAlteredApplications(state),
  };
};

const mapDispatchToProps = {
  addAppToHistory,
  addSelectedStudentIdSeed,
  clearSelectedStudents,
  getApplicationsAndStudents,
  checkApplicationRow,
  checkStudentRow,
  clearError,
  removeSelectedStudentIdSeed,
  setNoStudent,
  setSaveSuccessful,
  setSelectedConfidence,
  setSelectedIds,
  toggleHistory,
  writeApplicationWithStudentMatch,
};

export const FamilyMatchUtility = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FamilyMatchUtilityContainer)
);



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/FamilyMatchUtility.js